




































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { DateTime } from 'luxon';
import { IProposal, ICompanyType, IEmployee, IUser } from '../../models';
import EditorTest from '../../components/UI/EditorTest.vue';
import { client } from '../../store';
import { BaseDetail } from '../Base/BaseDetail';
import { Watch } from 'vue-property-decorator';
import { getDate, getUserFullName } from '../../helpers/functions';
const namespace = 'proposal';
const ns = { namespace };

@Component({
  methods: {
    getDate,
    getUserFullName,
  },
  data: () => ({
    DateTime,
  }),
  components: {
    EditorTest,
  },
})
export default class ProposalDetail extends BaseDetail<IProposal> {
  namespace = namespace;
  modal = false;
  @State('currentUser', { namespace: 'user' }) user: IUser;
  @State('entities', ns) entities: Record<string, IProposal>;
  @State('entities', { namespace: 'employee' }) employees: Record<
    string,
    IEmployee
  >;
  @Action('getEntities', { namespace: 'employee' }) getEmployees: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('createEntity', ns) createEntity: any;
  @Action('pushMessage', ns) pushMessage: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;

  beforeMount() {
    this.loadEntity();
  }
  async beforeUpdate() {
    if (this.entityId && !Object.keys(this.entity).length) {
      await this.loadEntity();
    }
  }
  showModal() {
    this.modal = true;
  }
  setDescription(val: string) {
    if (this.entity.description !== val)
      this.setValue(this.entityPatch, 'description', val);
  }
  attachToContractor(id: number) {
    client.post('/representatives/attach', {
      contractor_id: this.entity.contractor_id,
      representative_id: id,
    });
  }
}
